/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import {
  useEditarRegistroHojaDeVidaMutation,
  useObtenerAspirantePorIdQuery,
  useObtenerVerificacionesDeAspiranteQuery,
} from "src/redux/api/aspirantesApi";
import { ConceptosVerificacionProps } from "src/utils/aspirantes/verificaciones";
import EditorDatos from "src/components/editor-datos/EditorDatos";
import { Alert, AlertTitle, Box, CircularProgress, Typography } from "@mui/material";
import { LoadingButton } from "@mui/lab";

type CampoAEditar = {
  clave: string;
  valor: any;
  comentario?: string;
  campo: string;
  verificacionId?: string;
};

const CorreccionDatos = () => {
  const { aspiranteId } = useParams<{
    aspiranteId: string;
  }>();
  const [camposAeditar, setCamposAeditar] = useState<CampoAEditar[]>([]);
  const { data: aspiranteResp, isLoading: cargandoAspirante } = useObtenerAspirantePorIdQuery(aspiranteId, {
    skip: !aspiranteId,
  });
  const { data: verificacionesResp, isLoading: cargandoVerificaciones } = useObtenerVerificacionesDeAspiranteQuery(
    { aspiranteId: aspiranteId ?? ""  },
    { skip: !aspiranteId  },
  );

  const [editarDatos, {isSuccess}] = useEditarRegistroHojaDeVidaMutation();

  useEffect(() => {
    if (!verificacionesResp || !aspiranteResp) return;

    const nuevosValores = verificacionesResp.filter(
      (campo) => campo.estado === "DEVUELTO",
    );
    const campos = Object.entries(ConceptosVerificacionProps).reduce<
      CampoAEditar[]
    >((acc, [key, value]) => {
      if (nuevosValores.find((v: { concepto: string }) => v.concepto === key)) {
        acc.push({
          clave: key,
          valor: (aspiranteResp as any)[value.campo],
          campo: value.campo,
          comentario: nuevosValores.find((v: { concepto: string }) => v.concepto === key)?.comentarios ?? undefined,
          verificacionId: nuevosValores.find((v: { concepto: string }) => v.concepto === key)?.verificacionId ?? undefined
        });
      }
      return acc;
    }, []);

    setCamposAeditar(campos);
  }, [verificacionesResp, aspiranteResp]);

  if (!aspiranteId ) {
    return <div>Parámetros no válidos.</div>;
  }

  if (isSuccess) {
    return (<Box sx={{p:10, textAlign: 'justify'}}>
    <Alert severity="success" >
      <AlertTitle sx={{fontWeight: 'medium'}}>Información actualizada</AlertTitle>
      Hemos recibido tu información, debes estar pendiente a tu correo
      eléctrónico ya que durante los próximos días alguno de nuestros
      colaboradores se puede estar contactando contigo para solicitar
      información adicional.
    </Alert>
    </Box>)
  }

  if (cargandoAspirante || cargandoVerificaciones) {
    return <Box sx={{display: "flex", justifyContent: "center"}}>
    <CircularProgress color="primary" size={40} sx={{mt: 5}}/>;
    </Box>
  }

  return (
    <div>
      {camposAeditar.length > 0 ? (
        <Box display="flex" justifyContent="center">
          <Box width="90%">
            <Typography variant="h4"> Corrección de datos</Typography>
            <Alert severity="info">
              Revise cada uno de los comentarios y realice los cambios
              necesarios.
            </Alert>
            <br />
            <EditorDatos
              campos={camposAeditar as any}
              aspiranteId={aspiranteId}
              submit={(values: any) => {
                editarDatos({
                  aspiranteId: aspiranteId || "",
                  informacion: values,
                  actualizacionDocente: true
                })
              }}
            />
            <Box>
              <LoadingButton
                variant="contained"
                color="primary"
                sx={{ color: "white" }}
                type="submit"
                data-testid="btn-nuevo-maestro"
                form="form-editor"
              >
                Guardar
              </LoadingButton>
            </Box>
          </Box>
        </Box>
      ) : (
        <Box sx={{pt:4}}>No hay correcciones por realizar</Box>
      )}
    </div>
  );
};

export default CorreccionDatos;
